import { HTMLLogo, SASSLogo, TypescriptIcon } from "./icons"

export const snippetTypes = [
  {
    icon: { value: <HTMLLogo width="28" height="28" /> },
    toolTipText: "HTML5",
    title: "html",
    onclick: "html",
  },
  {
    icon: { value: <SASSLogo width="24" height="24" /> },
    toolTipText: "SASS",
    title: "css",
    onclick: "css",
  },
  {
    icon: { value: <TypescriptIcon width="24" height="24" /> },
    toolTipText: "Typescript",
    title: "typescript",
    onclick: "typescript",
  },
]
